import style from './IconButton.module.css';

interface IconButtonPropsInterface {
  icon: string;
  type?: 'button' | 'submit';
  onClick?: () => void;
  disabled?: boolean;
  label?: string;
}

function IconButton(props: IconButtonPropsInterface) {
  const {
    type,
    icon,
    onClick,
    disabled,
    label,
  } = props;

  const chosenIcon: string = String(icon);

  return (
    <button
      type={(type === 'submit' ? 'submit' : 'button')}
      className={`${style.button} ${style[chosenIcon]}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
    />
  );
}

IconButton.defaultProps = {
  type: 'button',
  onClick: () => {},
  disabled: false,
  label: undefined,
};

export default IconButton;
